<template>
  <div>
    <div class="title-div">燃气服务</div>

    <div class="content">
      <div class="main-box" @click="onSkip('查询')">
        <div class="title">查询</div>
        <div class="img-div"><img src="../../assets/fu-wu/fu-wu-1.png" alt="" width="53px" height="94px"></div>
        <div class="text-div">查询北京燃气集团管辖范围内所属用户的地址、表型、近12个月的充值缴费记录信息。</div>
      </div>

      <div class="main-box2" @click="onSkip('发票')">
        <div class="title">发票</div>
        <div class="img-div"><img src="../../assets/fu-wu/fu-wu-2.png" alt="" width="53px" height="94px"></div>
        <div class="text-div">对北京燃气集团管辖范围内所有普表（后付费）用户进行发票开具，暂不支持预付费表具开票。</div>
      </div>

      <div class="main-box3" @click="onSkip('报修')">
        <div class="title">报修</div>
        <div class="img-div"><img src="../../assets/fu-wu/fu-wu-3.png" alt="" width="53px" height="94px"></div>
        <div class="text-div">提供对北京燃气集团管辖范围内所属用户燃气表、管道阀门、燃气设备的保修业务及拆、改迁的个性化服务。</div>
      </div>

    </div>


  </div>






</template>

<script>
  export default {
    name: 'PCService',
    data(){
      return{

      }
    },
    mounted() {
      let title = this.$route.query.title;
      this.$router.push({ path: '/pcAccountNumberManagement', query: { title: title } })
    },
    methods: {
      // 路由跳转
      onSkip (val) {
        this.$router.push({ path: '/pcAccountNumberManagement', query: { title: val } })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .content{
    position: relative;
    top: 60px;
    width: 1500px;
    height: 400px;
  }

  .main-box {
    position: absolute;
    left: 200px;
    background-color: #FFFFFF;
    width: 356px;
    height: 158px;
    border-radius:2px;
    box-shadow: 0 2px 4px  #888888 ;
  }
  .main-box:hover{
    box-shadow: 4px 4px 4px  #888888 ;
    cursor: pointer;
  }
  .main-box2 {
    position: absolute;
    left: 600px;
    background-color: #FFFFFF;
    width: 356px;
    height: 158px;
    border-radius:2px;
    box-shadow: 0 2px 4px  #888888 ;
  }
  .main-box2:hover{
    box-shadow: 4px 4px 4px  #888888 ;
    cursor: pointer;
  }
  .main-box3 {
    position: absolute;
    left: 1000px;
    background-color: #FFFFFF;
    width: 356px;
    height: 158px;
    border-radius:2px;
    box-shadow: 0 2px 4px  #888888 ;
  }
  .main-box3:hover{
    box-shadow: 4px 4px 4px  #888888 ;
    cursor: pointer;
  }
  .title{
    width: 50px;
    position: relative;
    top: 18px;
    left: 109px;
    right: 211px;
    bottom: 116px;
    font-family: 微软雅黑;
    font-weight: bold;
    font-size: 18px;
  }
  .img-div{
    position: absolute;
    top: 55px;
    left: 29px;
    right: 274px;
    bottom: 12px;
    width: 53px;
    height: 94px;
  }
  .text-div{
    position: absolute;
    top: 55px;
    left: 108px;
    right: 49px;
    bottom: 12px;
    width: 199px;
    height: 66px;
    font-family: 微软雅黑;
    color: #999999;
    font-size: 16px;
  }
</style>
